// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuctionController from "./auction_controller"
application.register("auction", AuctionController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import DkpMenuController from "./dkp_menu_controller"
application.register("dkp-menu", DkpMenuController)

import DndMemberController from "./dnd_member_controller"
application.register("dnd-member", DndMemberController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import RaidController from "./raid_controller"
application.register("raid", RaidController)

import PartyController from "./party_controller"
application.register("party", PartyController)

import raidBoxController from "./raid_box_controller"
application.register("raid-box", raidBoxController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import BidController from "./bid_controller"
application.register("bid", BidController)

import MenuOptionsController from "./menu_options_controller"
application.register("menu-options", MenuOptionsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TippyHoverController from "./tippy_hover_controller"
application.register("tippy-hover", TippyHoverController)
